import React from "react";
import "./Header.css";
const Header = () => {
  return (
    <div className="cov19-header section_padding">
      <h1>COVID-19 Dashboard</h1>
    </div>
  );
};

export default Header;
